module.exports = __webpack_public_path__ + "static/media/referral_118.85c24582.png";